import { Box, BoxProps, Image, SpacerNew, TextNew, TextNewProps } from '@jfs/ui-new'
import { bulkEntityStringConstants } from '../../utils/constants'
import { CircularProgress } from '../FileSelectorInnerComp/CircularProgress'

interface SubmittingComponent {
  type: 'submit' | 'resubmit'
  screenType: 'bulkUpload' | 'tid' | 'retryEntityCreation' | 'bulkConfig' | 'bulkCard'
  message?: string
  percentage: number
}

const SubmittingComponent = ({ type = 'submit', screenType, message, percentage }: SubmittingComponent) => {
  const titleText = () => {
    if (screenType === 'bulkUpload') {
      if ((type = 'submit')) {
        return bulkEntityStringConstants[screenType].submittingFileLoaderText
      } else {
        return bulkEntityStringConstants[screenType].reSubmitLoaderText
      }
    } else if (screenType === 'retryEntityCreation') {
      return message?.length > 0 ? message : bulkEntityStringConstants[screenType].retryingCreation
    } else if (screenType === 'bulkConfig') {
      return bulkEntityStringConstants[screenType].submittingFileLoaderText
    }
  }

  return (
    <Box {...styles.mainContainer}>
      <Box {...styles.loaderImage}>
        <CircularProgress strokeWidth={2.5} textColor={'#000'} color={'#0186B0'} percentage={percentage} radius={32} />
        <Box {...styles.absImage}>
          <Image
            source={require('../../assets/images/hourglassLoader.svg')}
            height={24}
            width={24}
            resizeMode="center"
          />
        </Box>
      </Box>
      <SpacerNew size={16} />
      <TextNew {...styles.loaderText}>{titleText()}</TextNew>
    </Box>
  )
}

export { SubmittingComponent }

const styles = {
  mainContainer: {
    flex: 1,
    justify: 'center',
  } as BoxProps,
  loaderImage: {
    alignSelf: 'center',
    height: 64,
    width: 64,
    justify: 'center',
  } as BoxProps,
  loaderText: {
    fontSize: 14,
    lineHeight: 20,
    color: 'BLACK_21',
    fontFamily: 'jiotype-medium',
    textAlign: 'center',
  } as TextNewProps,
  absImage: {
    position: 'absolute',
    alignSelf: 'center',
    flex: 1,
  } as BoxProps,
}
